import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Screenshot_2023-11-11_184359-removebg-preview.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="yellow"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />
              I'm a versatile and passionate full-stack JavaScript web developer
              with a rich background in a multitude of technologies. My
              expertise spans across{" "}
              <span className="yellow">
                Angular, React, JavaScript, Python, Node.js,{" "}
              </span>{" "}
              and <span className="yellow">Java, </span> allowing me to craft
              solutions that seamlessly integrate into diverse ecosystems. I'm
              well-versed in powerful data visualization tools such as{" "}
              <span className="yellow">PowerBI</span> and{" "}
              <span className="yellow">Plotly</span>.
              <br />
              <br />
              During my free time, always eager to explore new technologies and
              enhance my skills. My commitment to the open-source community has
              driven me to contribute to various projects, and I take pride in
              building innovative applications using cutting-edge AI technology.
              &nbsp;
              <br />
              <br />
              In the cloud realm, I possess a foundational understanding of{" "}
              <span className="yellow">AWS</span>, leveraging its capabilities
              to enhance scalability and performance. When it comes to
              databases, I prefer the flexibility and efficiency of{" "}
              <span className="yellow">MongoDB</span>.
              <br />
              <br />I believe in the continuous pursuit of knowledge, always
              seeking opportunities to expand my skill set and stay at the
              forefront of technological advancements. My journey in the tech
              world is marked by a blend of creativity, dedication, and a
              genuine passion for creating meaningful and impactful solutions.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="yellow">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/sumitsarraf"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
